import React from 'react';
import './preloader.css';

const Preloader = () => {
    return (
        <div className={ 'preloader' } />
    );
};

export default Preloader;